import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, Divider, CircularProgress, Chip } from '@material-ui/core';
import { Pagination, STableLoader, FilterComponent, PageLoader, EmptyCollection, DeletePopUp, GoogleLocationField, RevisionHistory } from '../../shared_elements';
import { TechSpecsNav } from '../../elements'
import { UtilizationInfo, AssetInfo } from '../components'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AddIcon from '@material-ui/icons/Add';
import { globalDeleteService, globalExportService, globalPostService, globalLeaseGetService } from '../../../globalServices';
import useAssetInfo from '../hooks/useAssetInfo';
import { checkApiStatus, checkPermission, getLocalStorageInfo } from '../../utils_v2';
import { downloadFileType, numberWithCommas } from '../../../utils';
import { Flag, GetApp } from "@material-ui/icons";
import VisibilityIcon from '@material-ui/icons/Visibility';
import ExportMenu from "../../shared_elements/ExportMenu";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { getPermissionKey } from "..";
import { assetsValue, assetTypeValues, displayDateTimeFormat, fieldDateFormat } from "../../../constants";
import moment from "moment";
import { trackActivity } from "../../../utils/mixpanel";
import EditIcon from '@material-ui/icons/Edit';
import AddUtilization from "../components/AddUtilization";
import { DropzoneArea } from "material-ui-dropzone";
import Axios from "axios";
import { halcyonInstance, hanwahaInstance, regionalOneInstance } from "../../../shared/components";
import FilePreview from "../../shared_elements/FilePreview";
import AddUtilizationV2 from "../components/AddUtilizationV2";
import config from "../../../config";
import SaveAltIcon from "@material-ui/icons/SaveAlt"
const utilizationObj = {
    name: '',
    asset_id: null,
    asset_type: null,
    end_date: '',
    start_date: '',
    utilization_type: '',
    tsn: null,
    csn: null,
    asset_location: '',
    serviceability: '',
    remarks: '',
    escalation_region: '',
    unit_of_measure: '',
    cycles: null,
    hours: null,
    derate: null,
    egtm: null
}
const attachmentObj = {
    files: [],
}
const Attachmetns = ({ params, item, getResponseBack }) => {
    const [modal, setModal] = useState(false);
    const [deleteAttachment, setDeleteAttachment] = useState({ modal: false, data: null });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [circularLoader, setCircularloader] = useState(false)
    const [viewAttachment, setViewAttachment] = useState({ modal: false })
    const onDeleteAttachment = () => {
        setCircularloader(true);
        globalDeleteService(``)
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteAttachment({ modal: false, data: null });
                    getResponseBack({}, 'pageLoader');
                    enqueueSnackbar('Attachment Removed successfully', { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                }
                setCircularloader(false);
            })
    }
    const downloadFile = (data) => {
        Axios.get(data.url || data.download_url, { timeout: 600000, responseType: 'blob' })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', data.file_name);
                document.body.appendChild(link);
                link.click();
            })
    }
    return (
        <>
            {item?.attachments?.length ? <Tooltip arrow title="View Attachments"><span onClick={() => setModal(true)} style={{ cursor: "pointer" }} className="flex-centered"><AttachFileIcon color="primary" fontSize="small" />({item.attachments.length})</span></Tooltip> : null}
            {modal ?
                <Dialog
                    open={modal}
                    onClose={() => setModal(false)}
                    className='console-management-modal'
                    maxWidth="md"
                >
                    <DialogTitle id="scroll-dialog-title"> Attachment(s) </DialogTitle>
                    <DialogContent dividers={true}>
                        <div style={{ width: '520px' }}>
                            {item.attachments.map((attachment) =>
                                <>
                                    <Grid container spacing={1}>
                                        <Grid item md={10}>
                                            <p style={{ fontSize: "small", margin: "3px 0 5px 0" }}>{attachment.file_name}</p>
                                        </Grid>
                                        <Grid item md={2}>
                                            <ul className="list-inline" style={{ float: 'right' }}>
                                                <Tooltip placement="bottom-end" title='View Attachment' arrow>
                                                    <li className="list-inline-item">
                                                        <VisibilityIcon style={{ marginTop: "5px", cursor: "pointer" }} fontSize="small" color="primary" onClick={() => setViewAttachment({ modal: true, data: attachment })} />
                                                    </li>
                                                </Tooltip>
                                                <Tooltip placement="bottom-end" title='Download Attachment' arrow>
                                                    <li className="list-inline-item">
                                                        <GetApp style={{ marginTop: "5px", cursor: "pointer" }} fontSize="small" color="primary" onClick={() => downloadFile(attachment)} />
                                                    </li>
                                                </Tooltip>
                                                <Tooltip placement="bottom-end" title='Delete Attachment' arrow>
                                                    <li className="list-inline-item">
                                                        {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && item.custom_utilization === true ?
                                                            <DeleteOutlineIcon style={{ marginTop: "5px", cursor: "pointer" }} onClick={() => { setDeleteAttachment({ modal: true, data: attachment.uuid }) }} color="secondary" fontSize="small" /> : null
                                                        }
                                                    </li>
                                                </Tooltip>
                                            </ul>
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                </>
                            )}
                            {!item?.attachments?.length ? <div style={{ textAlign: 'center', border: 'dotted', color: '#d2e1e7', padding: '50px' }}><EmptyCollection title={<h4 style={{ color: '#a0bdc8' }}>No Attachment found</h4>} /></div> : null}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setModal(false)} color="primary" size="small" variant="outlined">Close</Button>
                    </DialogActions>
                </Dialog> : null
            }
            {deleteAttachment.modal ?
                <DeletePopUp
                    modal={deleteAttachment.modal}
                    title='Delete Attachment'
                    content={`Are you sure, you want to Delete Attachment?`}
                    toggleModalFn={() => setDeleteAttachment({ modal: false, data: null })}
                    deleteRecordFn={onDeleteAttachment}
                    circularloader={circularLoader}
                /> : null
            }
            {viewAttachment?.modal ?
                <FilePreview
                    downloadFile={downloadFile}
                    toggleModalFn={() => setViewAttachment({ modal: false })}
                    fileInfo={viewAttachment?.data}
                />
                : null}
        </>
    )

}
const AddAttachments = ({ assetInfoData, params, item, getResponseBack }) => {
    const [attachment, setAttachment] = useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState()
    const [files, setFiles] = useState([]);

    const addAttachment = () => {
        let formData = new FormData();
        if (files.length) {
            files.map(item => {
                formData.append('files', item)
            })
        }
        formData.append('asset_type', assetInfoData?.asset_type.type);
        formData.append('asset_slug', params?.aircraft_slug);
        formData.append('model_type', '1');
        formData.append('object_id', item?.id)
        setLoading(true)
        globalPostService(``, formData)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    trackActivity('Console Management', { page_title: 'Utilization', asset_type: `${params?.type}`, asset_name: `${assetInfoData?.serial_number}`, event_type: 'Item Added', event_desc: 'Added custom utiliztion attachment from utiliztion form' });
                    setAttachment(false);
                    getResponseBack()
                }
                setLoading(false);
            })
    }
    return (
        <>
            {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && item.custom_utilization === true ?
                <Tooltip placement='bottom-start' arrow title={"Add Attachment"}><span onClick={() => item.attachments.length !== 5 ? setAttachment(true) : null} style={{ cursor: "pointer" }} className="flex-centered"><AttachFileIcon disabled color={item.attachments.length !== 5 ? "primary" : 'disabled'} fontSize="small" /></span></Tooltip> : null}
            {attachment ?
                <Dialog
                    open={attachment}
                    onClose={() => setAttachment(false)}
                    className='console-management-modal'
                    maxWidth="md"
                >
                    <DialogTitle id="scroll-dialog-title">
                        Add Attachment
                    </DialogTitle>
                    <DialogContent dividers={true} style={{ width: '600px' }}>
                        <Grid container spacing={1}>
                            <Grid item md={12}>
                                <div>
                                    <DropzoneArea
                                        acceptedFiles={['.pdf', '.docx', '.csv', '.xls', '.xlsx', '.jpg', '.jpeg', '.png']}
                                        filesLimit={5}
                                        maxFileSize={104857600}
                                        showPreviewsInDropzone={false}
                                        useChipsForPreview={true}
                                        showPreviews={true}
                                        dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                        dropzoneClass="drag-drop-cnt"
                                        showAlerts={['info', 'error']}
                                        alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                        clearOnUnmount={true}
                                        onChange={(files) => setFiles(files)}
                                        multiple
                                    />
                                </div>
                                <span style={{ fontSize: '11px' }} className='files-upload-limit' > Note: Only pdf, docx, csv, xls, xlsx, jpg, jpeg and png files are supported (Max Upto 5 Files )</span>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={isLoading} onClick={() => setAttachment(false)} color='primary' size='small' variant='outlined'>Cancel</Button>
                        <Button disabled={isLoading || !files.length} onClick={addAttachment} color='primary' size='small' variant='contained'>
                            {isLoading ? <CircularProgress size={24} /> : 'Save'}
                        </Button>
                    </DialogActions>
                </Dialog> : null}
        </>

    )
}
const UtilizationHd = ({ params }) => {
    return (
        <TableHead>
            <TableRow>

                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }} >Action(s)</TableCell>
                <TableCell >Period</TableCell>
                <TableCell >Hours</TableCell>
                <TableCell >Cycles</TableCell>
                <TableCell >TSN(Hrs)</TableCell>
                <TableCell >CSN(Cycles)</TableCell>
                {params?.type === "aircraft" ? <TableCell >BH(Block Hours)</TableCell> : null}
                {params?.type === "engine" ? <TableCell >De-Rate</TableCell> : null}
                {params?.type === 'engine' ? <TableCell>{regionalOneInstance ? 'EGT Margin' : 'EGTM'}</TableCell> : null}
                <TableCell >Utilization Type</TableCell>
                <TableCell >Location</TableCell>
                <TableCell >Serviceability</TableCell>
                <TableCell >Remarks</TableCell>
            </TableRow>
        </TableHead>
    )
}
const UtilizationList = ({ item, onDelete, params, onEdit, assetInfoData, getResponseBack, id, index }) => {
    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field],
        });
    };
    const calculateWidth = (minWidth, maxWidth, content, minCount, maxCount) => {
        let width = 130;
        if (content?.length > minCount && content?.length <= maxCount) {
            width = Math.max(content?.length * 10, minWidth);
        } else if (content?.length > maxCount) {
            width = maxWidth;
        }
        return `${Math.min(width, maxWidth)}px`;
    };
const hoursDisplayValue = (item?.custom_utilization === true || [5, 4, 3,7].includes(item?.utilization_type?.value)) ? '--' : item?.hours || '--';
const cyclesDisplayValue = (item?.custom_utilization === true || [5, 4, 3,7].includes(item?.utilization_type?.value)) ? '--' : item?.cycles || '--';

    return (
        <TableRow style={{ backgroundColor: item.custom_utilization === true ? '' : '' }}>
            <TableCell  style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, }}>
                <div style={{ minWidth: '130px' }}>
                    <ul className="list-inline">
                        {/* {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && item.custom_utilization === true ?
                            <li className="list-inline-item hover-inline">
                                <Tooltip><AddAttachments getResponseBack={getResponseBack} params={params} assetInfoData={assetInfoData} item={item} /></Tooltip>
                            </li> : null
                        } */}
                        {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && item.custom_utilization === true ?
                            <li className="list-inline-item hover-inline" >
                                <Tooltip onClick={() => onEdit()} title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                            </li> : null
                        }
                        {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && item.custom_utilization === true ?
                            <li className="list-inline-item hover-inline">
                                <Tooltip onClick={() => { onDelete() }} title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                            </li> : null
                        }
                        {/* {item.custom_utilization === true ?
                            <li className='list-inline-item'>
                                <RevisionHistory id={id} assetInfoData={assetInfoData} isExp={checkPermission('technical_specs', getPermissionKey(params.type), 'EXP')} params={{ type: 'utilization', aircraft_slug: 'ZjLWwv' }} buttonType={true} url={`audit/console/amutilization/?action=0,1&object_id=${id}`} />
                            </li> : null
                        } */}
                    </ul>
                </div>
            </TableCell>
            <TableCell >
                <div className="flex-centered" style={{ minWidth: '280px' }}>
                    {moment(item?.start_date).format(displayDateTimeFormat)} to {moment(item?.end_date).format(displayDateTimeFormat) || '--'}
                    <Attachmetns params={params} getResponseBack={getResponseBack} item={item} />
                </div>
                {item.custom_utilization === true ? <Chip label={'Custom Utilization'} color="" size="small" style={{ fontSize: '12px' }} /> : null}
                {item.custom_utilization === true && params.type === 'engine' ? item.sync_llp === true && params.type === 'engine' ? <Chip label={'LLPs are Synced'} color="" size="small" style={{ fontSize: '12px', marginLeft: '3px', color: "white", backgroundColor: 'green' }} /> : <Chip label={'LLPs are not Synced'} color="" size="small" style={{ fontSize: '12px', marginLeft: '3px' }} /> : null}
            </TableCell>
            <TableCell> <div style={{ width: calculateWidth(0, 130, hoursDisplayValue, 0, 0) }}> {numberWithCommas(hoursDisplayValue)} </div> </TableCell>
            <TableCell> <div style={{ width: calculateWidth(0, 130, cyclesDisplayValue, 0, 0) }}> {numberWithCommas(cyclesDisplayValue)} </div> </TableCell>
            <TableCell ><div style={{ width: calculateWidth(0, 130, item?.tsn || '--', 8, 10) }}>{numberWithCommas((item?.tsn === 0 ? 0 : item?.tsn) || '--')}</div></TableCell>
            <TableCell ><div style={{ width: calculateWidth(0, 130, item?.csn || '--', 8, 10) }}>{numberWithCommas((item?.csn === 0 ? 0 : item?.csn) || '--')}</div></TableCell>
            {params?.type === "aircraft" ? <TableCell ><div style={{ width: calculateWidth(0, 130, item?.block_hours || '--', 0, 0) }}>{item.block_hours ? numberWithCommas(item.block_hours) : '--'}</div></TableCell> : null}
            {params?.type === "engine" ? <TableCell ><div style={{ width: calculateWidth(0, 130, item?.derate || '--', 0, 0) }}>{(item?.derate === 0 ? 0 : item?.derate) || '--'}</div></TableCell> : null}
            {params?.type === "engine" ? <TableCell><div style={{ width: calculateWidth(0, 130, item?.egtm || '--', 8, 15) }}>{item.egtm || "--"}</div></TableCell> : null}
            <TableCell><div style={{ width: calculateWidth(120, 180, item?.utilization_type?.label || '--', 0, 0) }}>{item?.utilization_type?.label}</div></TableCell>
            <TableCell ><div style={{ width: calculateWidth(100, 350, item?.asset_location || '--', 0, 30) }}>{item?.asset_location || '--'}</div></TableCell>
            <TableCell><div style={{ width: calculateWidth(0, 180, item?.serviceability || '--', 0, 0) }}>{item?.serviceability || '--'}</div></TableCell>
            <TableCell>
                {item?.remarks && item?.remarks?.length > 30 ? (
                    <div style={{ width: calculateWidth(200, 350, item?.remarks, 30, '') }} >
                        {showMore[item?.field] && showMore[item?.field] ? (
                            <span> {item?.remarks}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  >  less </a>
                            </span>
                        ) : (
                            <span> {item.remarks.substring(0, 25)}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > ..more </a>
                            </span>
                        )}
                    </div>
                ) :
                    <div style={{ width: calculateWidth('150', '195', item.remarks, '1', '25') }}>{item.remarks || '--'}</div>
                }

            </TableCell>
        </TableRow>
    );
}
const getUtilizationsTableOffset = (hasList, isEdit, instanceBasedTableHeight) => {
    if (hasList) {
        if (isEdit) return instanceBasedTableHeight ? 510 : 440;
        return instanceBasedTableHeight ? 490 : 410;
    }
    if (isEdit) return instanceBasedTableHeight ? 455 : 395;
    return instanceBasedTableHeight ? 440 : 360;
}
const UtilizationsV2 = ({ params }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [utilizationsInfo, setUtilizationsInfo] = useState({ list: [], pagination: {} });
    const [addEditUtilization, setAddEditUtilization] = useState({ modal: false, data: [] });
    const [editUtil, setEditUtil] = useState({ modal: false, data: [] });
    const [deleteUtilization, setDeleteUtilization] = useState({ modal: false, data: null });
    const { assetInfoData, assetSkeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    const [circularloader, setCircularloader] = useState(false)
    const [isFiltered, setIsFiltered] = useState(false);
    const [utilizationInfoRefreshKey, setUtilizationInfoRefreshKey] = useState(0);
    const [isUtilInfoEdit, setIsUtilInfoEdit] = useState(false);
    const leaseURLEndPoint = config.api.leaseRevampNetworkInterface
    const instanceBasedTableHeight = (hanwahaInstance || halcyonInstance || regionalOneInstance)
    const filterOption = (
        {
            "start_date": {
                "inputType": 'date',
                "placeholder": 'From Date',
                "title": 'From Date'
            }, "end_date": {
                "inputType": 'date',
                "placeholder": 'To Date',
                "title": 'To Date'
            },
        })
    useEffect(() => {
        getUtilizations({per_page:50}, 'skeletonLoader');
    }, []);
    const getUtilizations = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalLeaseGetService(`${leaseURLEndPoint}/asset-utilizations/?asset_type=${assetsValue[params.type]}&asset_slug=${params.aircraft_slug}`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setUtilizationsInfo(response.data.data)
                    delete query.page
                    delete query.per_page
                    setFilter(query)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const reloadUtilizationsList = () => {
        getUtilizations({ ...filter, page: utilizationsInfo?.pagination?.page || 1, per_page: utilizationsInfo?.pagination?.per_page || 50 }, 'pageLoader');
        setUtilizationInfoRefreshKey(prevKey => prevKey + 1);
    }

    const onDeleteUtilization = () => {
        setCircularloader(true);
        globalDeleteService(`${leaseURLEndPoint}/custom-utilizations/${deleteUtilization?.data?.slug}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteUtilization({ modal: false, data: null });
                    reloadUtilizationsList();
                    enqueueSnackbar('Custom Utilization deleted successfully', { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                }
                setCircularloader(false);
            })
    }
    const onExportReport = (query) => {
        setLoading(true);
        globalExportService(`${leaseURLEndPoint}/asset-utilizations/?asset_type=${assetsValue[params.type]}&asset_slug=${params.aircraft_slug}&export=true&custom_util=true`, query)
            .then(response => {
                downloadFileType(response, `${assetTypeValues[assetInfoData?.asset_type.type].label} ${assetInfoData.serial_number} utilizationlist ${moment().format(fieldDateFormat)}`, "xlsx")
                trackActivity('Console Management', { page_title: 'Utilization', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Exported', event_desc: 'Utilization Exported Successfully' });
                // enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                setLoading(false);
            })
    }

    return (
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 165}px` }}>
                <TechSpecsNav />
                <div className="tech-specs-content" >
                    <div style={{ padding: '0px 10px' }}>
                        {skeletonLoader ? <STableLoader count={8} /> :
                            <>
                                <div>
                                    <UtilizationInfo assetInfoData={assetInfoData} refreshKey={utilizationInfoRefreshKey} onEditChange={setIsUtilInfoEdit} />
                                </div>
                                <div>
                                    <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px' }}>
                                        <Grid container spacing={1} alignItems="center">
                                            <Grid item md={6}>
                                                {isFiltered  ?
                                                    <FilterComponent
                                                        filter={filter}
                                                        filterMenu={filterOption}
                                                        getResponseBack={(applyFilter) => { setIsFiltered(true); getUtilizations({ ...applyFilter, page: 1, per_page: utilizationsInfo?.pagination?.per_page || 50 }, 'pageLoader') }}
                                                    /> : null}
                                            </Grid>
                                            <Grid item md={6}>
                                                <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                                    {checkPermission('technical_specs', getPermissionKey(params.type), 'U') ?
                                                        <Tooltip placement='bottom-end' title={getLocalStorageInfo()?.user?.permission?.contracts ? 'This option enables the option to add Custom Utilization. To add monthly utilization, please add it via the Lease Application.' : ''}>
                                                            <li className='list-inline-item'>
                                                                <Button onClick={() => setAddEditUtilization({ modal: true, data: [{ ...utilizationObj, asset_id: assetInfoData?.id, asset_type: assetInfoData?.asset_type?.type }] })} variant="contained" color="primary" size="small" ><AddIcon style={{ fontSize: '1.15rem' }} />ADD Utilization</Button>
                                                            </li>
                                                        </Tooltip> : null
                                                    }
                                                    {utilizationsInfo.list.length && checkPermission('technical_specs', getPermissionKey(params.type), 'EXP') ?
                                                        <li className='list-inline-item'>
                                                            {/* <ExportMenu
                                                                // files={[{ title: 'Excel', extension: 'xlsx' }, { title: 'Pdf', extension: 'pdf' },]}
                                                                exportReportFn={(file) => onExportReport(filter)}
                                                            /> */}
                                                             <Button variant="outlined" size="small"  color="primary"  onClick={() => onExportReport(filter)} > <SaveAltIcon /> Export</Button>
                                                        </li> : null
                                                    }
                                                </ul>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                    <Paper square>
                                        <div style={{height:`${window.innerHeight - getUtilizationsTableOffset(utilizationsInfo?.list?.length, isUtilInfoEdit, instanceBasedTableHeight)}px`,overflow:'auto',marginTop: "3px"}}>
                                        <Table className='mui-table-format' stickyHeader>
                                            <UtilizationHd params={params} />
                                            <TableBody>
                                                {utilizationsInfo.list.map((item, index) =>
                                                    <UtilizationList
                                                        params={params}
                                                        assetInfoData={assetInfoData}
                                                        key={index}
                                                        index={index}
                                                        item={item}
                                                        id={item.id}
                                                        getResponseBack={() => getUtilizations()}
                                                        onEdit={() => setEditUtil({ modal: true, data: item })}
                                                        onDelete={() => setDeleteUtilization({ modal: true, data: item })}
                                                    />
                                                )}
                                            </TableBody>
                                        </Table>
                                        {!utilizationsInfo?.list?.length > 0 ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                        </div>
                                    </Paper>
                                    <Paper square>
                                        <Pagination
                                            pagination={utilizationsInfo.pagination}
                                            onChangePage={(event, newPage) => getUtilizations({ ...filter, page: newPage + 1, per_page: utilizationsInfo.pagination.per_page }, 'pageLoader')}
                                            onChangeRowsPerPage={(event) => getUtilizations({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                                        />
                                    </Paper>
                                </div>
                            </>
                        }
                    </div>
                </div>
                {editUtil.modal ?
                    <AddUtilizationV2
                        params={params}
                        addEditUtilization={editUtil}
                        assetInfoData={assetInfoData}
                        utilizationsInfo={utilizationsInfo}
                        toggleModalFn={() => setEditUtil({ modal: false, data: null })}
                        getResponseBack={reloadUtilizationsList}
                        leaseURLEndPoint={leaseURLEndPoint}
                    /> : null
                }
                {addEditUtilization.modal ?
                    <AddUtilizationV2
                        assetInfoData={assetInfoData}
                        addEditUtilization={addEditUtilization}
                        utilizationsInfo={utilizationsInfo}
                        toggleModalFn={() => setAddEditUtilization({ modal: false, utilization: [] })}
                        getResponseBack={reloadUtilizationsList}
                        leaseURLEndPoint={leaseURLEndPoint}
                    /> : null
                }
                {deleteUtilization.modal ?
                    <DeletePopUp
                        modal={deleteUtilization.modal}
                        title='Delete Utilization'
                        content={`Are you sure, you want to Delete Custom Utilization?`}
                        toggleModalFn={() => setDeleteUtilization({ modal: false, data: null })}
                        deleteRecordFn={onDeleteUtilization}
                        circularloader={circularloader}
                    /> : null
                }

                {isLoading ? <PageLoader /> : null}

            </Paper>
        </section>

    )
}
export default UtilizationsV2;